import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { C, FONT } from '../theme/tokens';
import BETCalculationsScreen from '../screens/bet/BETCalculationsScreen';
import BETPressurizationScreen from '../screens/bet/calculations/BETPressurizationScreen';
import BETDepressurizationScreen from '../screens/bet/calculations/BETDepressurizationScreen';
import BETAirLeakageRateScreen from '../screens/bet/calculations/BETAirLeakageRateScreen';
import BETEffectiveLeakageAreaScreen from '../screens/bet/calculations/BETEffectiveLeakageAreaScreen';
import BETAirChangesPerHourScreen from '../screens/bet/calculations/BETAirChangesPerHourScreen';
import BETRegressionScreen from '../screens/bet/calculations/BETRegressionScreen';

const Stack = createStackNavigator();

function useStackScreenOptions() {
  return {
    headerStyle: { backgroundColor: C.panel },
    headerTintColor: C.ink,
    headerTitleStyle: {
      fontFamily: FONT.sansBold,
      fontSize: 16,
      color: C.ink,
    },
    headerShadowVisible: false,
    headerBackTitleVisible: false,
    cardStyle: { backgroundColor: C.bg },
  };
}

export default function BETNavigator() {
  const screenOptions = useStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen name="BETCalculations" component={BETCalculationsScreen} options={{ title: 'Calculations' }} />
      <Stack.Screen name="BETPressurization" component={BETPressurizationScreen} options={{ title: 'ASTM E779 Pressurization' }} />
      <Stack.Screen name="BETDepressurization" component={BETDepressurizationScreen} options={{ title: 'ASTM E1827 Depressurization' }} />
      <Stack.Screen name="BETRegression" component={BETRegressionScreen} options={{ title: 'Multi-Point Regression' }} />
      <Stack.Screen name="BETAirLeakageRate" component={BETAirLeakageRateScreen} options={{ title: 'Air Leakage Rate' }} />
      <Stack.Screen name="BETEffectiveLeakageArea" component={BETEffectiveLeakageAreaScreen} options={{ title: 'Effective Leakage Area' }} />
      <Stack.Screen name="BETAirChangesPerHour" component={BETAirChangesPerHourScreen} options={{ title: 'Air Changes Per Hour' }} />
    </Stack.Navigator>
  );
}
